import React from "react";
import { TableCell, TableRow } from "../../../../../components/ui/common/table";
import ProcessDetailPanel from "../../processDetail/ProcessDetailPanel";
import { COLUMN_COUNT } from "../constants/processRecords.constants";
import { ApiProcessingRecord, GateKind } from "../types/processRecords.types";

interface ProcessExpandedRowProps {
  process: ApiProcessingRecord;
  gateKind: GateKind;
  onSaveCipSip: (updated: ApiProcessingRecord) => void;
  disabled?: boolean;
}

/** Full-width row holding the lazily-loaded detail panel for an expanded process. */
const ProcessExpandedRow: React.FC<ProcessExpandedRowProps> = ({
  process,
  gateKind,
  onSaveCipSip,
  disabled = false
}) => (
  <TableRow className="tw-bg-muted/20 hover:tw-bg-muted/20">
    <TableCell colSpan={COLUMN_COUNT} className="tw-p-3">
      <ProcessDetailPanel
        process={process}
        gateKind={gateKind}
        onSaveCipSip={onSaveCipSip}
        disabled={disabled}
      />
    </TableCell>
  </TableRow>
);

export default ProcessExpandedRow;
